<div class="pdf-view">
  <button type="button" *ngIf="filename && !hideControls" (click)="downloadDocument()"
    class="btn download-button no-border-radius-right no-border-radius-left"
    ngbTooltip="{{ 'common.pdfViewer.downloadDocument' | translate }}">
    <qpoint-icon [icon]="'download'"></qpoint-icon>
  </button>
  <button *ngIf="!hideControls" type="button" (click)="handleFullscreenMode()"
    class="btn full-screen-button no-border-radius-right no-border-radius-left"
    ngbTooltip="{{ 'common.pdfViewer.fullscreen' | translate }}">
    <qpoint-icon [icon]="isFullscreenDialogReference ? 'compress-alt' : 'expand-alt'"></qpoint-icon>
  </button>
  <kendo-pdfviewer *ngIf="pdfSource !== null && isString(pdfSource); else arraySource" 
  [style.visibility]="pdfIsLoading ? 'hidden' : 'visible'" style="width: 100%; height: 100%" [url]="pdfSource"
  (load)="callBackFn($event)" [zoom]="currentZoomLevel" (pageChange)="onPageChange($event)"></kendo-pdfviewer>
  <ng-template #arraySource>¨
    <kendo-pdfviewer *ngIf="pdfSource !== null && isArrayBuffer(pdfSource)" 
    [style.visibility]="pdfIsLoading ? 'hidden' : 'visible'" style="width: 100%; height: 100%" [arrayBuffer]="pdfSource"
    (load)="callBackFn($event)" [zoom]="currentZoomLevel" (pageChange)="onPageChange($event)"></kendo-pdfviewer>
  </ng-template>
  <qpoint-loading-spinner [size]="3" [cover]="false" [visible]="pdfIsLoading"></qpoint-loading-spinner>
  <div class="zoom-controls" *ngIf="!hideControls">
    <button class="btn no-border-radius-right" type="button" disabled>
      {{'common.pdfViewer.page' | translate}} {{ currentPdfPage }} / {{ totalPdfPages }}
    </button>
    <div class="btn-group" role="group">
      <button type="button" (click)="zoomOut()" class="btn no-border-radius-left"
        ngbTooltip="{{ 'common.zoomOut' | translate }}">
        <qpoint-icon icon="minus"></qpoint-icon>
      </button>
      <button type="button" class="btn" (click)="setDefaultZoom()" ngbTooltip="{{ 'common.reset' | translate }}">
        <qpoint-icon icon="search-plus"></qpoint-icon>
      </button>
      <button type="button" (click)="zoomIn()" class="btn" ngbTooltip="{{ 'common.zoomIn' | translate }}">
        <qpoint-icon icon="plus"></qpoint-icon>
      </button>
    </div>
  </div>
</div>
